import '../assets/NcAssistantIcon-CxXrcBfu.css';
import { defineComponent, useCssVars, computed, openBlock, createElementBlock, normalizeClass, createElementVNode, unref } from "vue";
import { p as mdiCreation } from "./mdi-CpchYUUV.mjs";
import { useIsDarkTheme } from "../composables/useIsDarkTheme/index.mjs";
import { c as createElementId } from "./createElementId-DhjFt1I9.mjs";
import { _ as _export_sfc } from "./_plugin-vue_export-helper-1tPrXgE0.mjs";
const _hoisted_1 = ["id"];
const _hoisted_2 = ["id"];
const _hoisted_3 = ["d", "fill"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "NcAssistantIcon",
  props: {
    inline: { type: Boolean },
    size: { default: 20 }
  },
  setup(__props) {
    useCssVars((_ctx) => ({
      "6629513e": sizePx.value
    }));
    const props = __props;
    const isDarkTheme = useIsDarkTheme();
    const gradientId = createElementId();
    const sizePx = computed(() => `${props.size}px`);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("span", {
        "aria-hidden": "true",
        class: normalizeClass([_ctx.$style.assistantIcon, _ctx.inline && _ctx.$style.assistantIcon_inline]),
        role: "img"
      }, [
        (openBlock(), createElementBlock("svg", {
          class: normalizeClass(_ctx.$style.assistantIcon__svg),
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, [
          createElementVNode("defs", null, [
            unref(isDarkTheme) ? (openBlock(), createElementBlock("linearGradient", {
              key: 0,
              id: unref(gradientId),
              gradientTransform: "rotateX(285)"
            }, [..._cache[0] || (_cache[0] = [
              createElementVNode("stop", {
                offset: "15%",
                "stop-color": "#CDACE7"
              }, null, -1),
              createElementVNode("stop", {
                offset: "40%",
                "stop-color": "#008FDB"
              }, null, -1),
              createElementVNode("stop", {
                offset: "82%",
                "stop-color": "#A180E0"
              }, null, -1)
            ])], 8, _hoisted_1)) : (openBlock(), createElementBlock("linearGradient", {
              key: 1,
              id: unref(gradientId),
              gradientTransform: "rotateX(285)"
            }, [..._cache[1] || (_cache[1] = [
              createElementVNode("stop", {
                offset: "15%",
                "stop-color": "#9669D3"
              }, null, -1),
              createElementVNode("stop", {
                offset: "40%",
                "stop-color": "#00679E"
              }, null, -1),
              createElementVNode("stop", {
                offset: "80%",
                "stop-color": "#492083"
              }, null, -1)
            ])], 8, _hoisted_2))
          ]),
          createElementVNode("path", {
            d: unref(mdiCreation),
            fill: `url('#${unref(gradientId)}')`
          }, null, 8, _hoisted_3)
        ], 2))
      ], 2);
    };
  }
});
const assistantIcon = "_assistantIcon_2koBz";
const assistantIcon_inline = "_assistantIcon_inline_kJSUg";
const assistantIcon__svg = "_assistantIcon__svg_V8CXC";
const style0 = {
  "material-design-icon": "_material-design-icon_mH0R6",
  assistantIcon,
  assistantIcon_inline,
  assistantIcon__svg
};
const cssModules = {
  "$style": style0
};
const NcAssistantIcon = /* @__PURE__ */ _export_sfc(_sfc_main, [["__cssModules", cssModules]]);
export {
  NcAssistantIcon as N
};
//# sourceMappingURL=NcAssistantIcon-Cf0B3EsL.mjs.map
